/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
export const AuthAuthPermissions = {
    PROJECT_CREATION: "PROJECT_CREATION",
    DATA_UPLOAD: "DATA_UPLOAD",
    DATA_LABELING: "DATA_LABELING",
    LABELING_REVIEW: "LABELING_REVIEW",
    MODEL_CREATION: "MODEL_CREATION",
    INFERENCE: "INFERENCE",
    SYSTEM_MANAGEMENT: "SYSTEM_MANAGEMENT",
    EDGE: "EDGE",
};
import axios from "axios";
import qs from "qs";
export var ContentType;
(function (ContentType) {
    ContentType["Json"] = "application/json";
    ContentType["FormData"] = "multipart/form-data";
    ContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
    ContentType["Text"] = "text/plain";
})(ContentType || (ContentType = {}));
export class HttpClient {
    instance;
    securityData = null;
    securityWorker;
    secure;
    format;
    constructor({ securityWorker, secure, format, ...axiosConfig } = {}) {
        this.instance = axios.create({
            ...axiosConfig,
            baseURL: axiosConfig.baseURL || "",
            paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "indices" }),
        });
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    setSecurityData = (data) => {
        this.securityData = data;
    };
    mergeRequestParams(params1, params2) {
        const method = params1.method || (params2 && params2.method);
        return {
            ...this.instance.defaults,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...((method && this.instance.defaults.headers[method.toLowerCase()]) || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {}),
            },
        };
    }
    stringifyFormItem(formItem) {
        if (typeof formItem === "object" && formItem !== null) {
            return JSON.stringify(formItem);
        }
        else {
            return `${formItem}`;
        }
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            const propertyContent = property instanceof Array ? property : [property];
            for (const formItem of propertyContent) {
                const isFileType = formItem instanceof Blob || formItem instanceof File;
                formData.append(key, isFileType ? formItem : this.stringifyFormItem(formItem));
            }
            return formData;
        }, new FormData());
    }
    request = async ({ secure, path, type, query, format, body, ...params }) => {
        const secureParams = ((typeof secure === "boolean" ? secure : this.secure) &&
            this.securityWorker &&
            (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const responseFormat = format || this.format || undefined;
        if (type === ContentType.FormData && body && body !== null && typeof body === "object") {
            body = this.createFormData(body);
        }
        if (type === ContentType.UrlEncoded && body && body !== null && typeof body === "object") {
            body = qs.stringify(body);
        }
        if (type === ContentType.Text && body && body !== null && typeof body !== "string") {
            body = JSON.stringify(body);
        }
        return this.instance.request({
            ...requestParams,
            headers: {
                ...(requestParams.headers || {}),
                ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
            },
            params: query,
            responseType: responseFormat,
            data: body,
            url: path,
        });
    };
}
/**
 * @title RVAI Auth Service
 * @version 0.1.0
 */
export class Api extends HttpClient {
    license = {
        /**
         * No description
         *
         * @tags license
         * @name GetLicense
         * @summary Get License
         * @request GET:/license
         * @secure
         */
        getLicense: (params = {}) => this.request({
            path: `/license`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    livez = {
        /**
         * @description Get application heartbeat.
         *
         * @tags monitor
         * @name GetHeartbeat
         * @summary Get Heartbeat
         * @request GET:/livez
         * @secure
         */
        getHeartbeat: (params = {}) => this.request({
            path: `/livez`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    login = {
        /**
         * No description
         *
         * @tags authentication
         * @name Login
         * @summary Login
         * @request POST:/login
         * @secure
         */
        login: (data, params = {}) => this.request({
            path: `/login`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    logout = {
        /**
         * No description
         *
         * @tags authentication
         * @name Logout
         * @summary Logout
         * @request POST:/logout
         * @secure
         */
        logout: (params = {}) => this.request({
            path: `/logout`,
            method: "POST",
            secure: true,
            ...params,
        }),
    };
    m2M = {
        /**
         * No description
         *
         * @tags authentication
         * @name Oauth2Login
         * @summary Oauth2 Login
         * @request POST:/m2m/login
         * @secure
         */
        oauth2Login: (data, params = {}) => this.request({
            path: `/m2m/login`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.UrlEncoded,
            format: "json",
            ...params,
        }),
        /**
         * No description
         *
         * @tags authentication
         * @name Oauth2Refresh
         * @summary Oauth2 Refresh
         * @request POST:/m2m/refresh
         * @secure
         */
        oauth2Refresh: (data, params = {}) => this.request({
            path: `/m2m/refresh`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.UrlEncoded,
            format: "json",
            ...params,
        }),
    };
    permissions = {
        /**
         * @description List all permissions. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name ListPermissions
         * @summary List Permissions
         * @request GET:/permissions
         * @secure
         */
        listPermissions: (params = {}) => this.request({
            path: `/permissions`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
    };
    prometheus = {
        /**
         * No description
         *
         * @tags monitor
         * @name GetPrometheusMetrics
         * @summary Get Prometheus Metrics
         * @request GET:/prometheus
         * @secure
         */
        getPrometheusMetrics: (params = {}) => this.request({
            path: `/prometheus`,
            method: "GET",
            secure: true,
            ...params,
        }),
    };
    roles = {
        /**
         * @description List all roles. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name ListRoles
         * @summary List Roles
         * @request GET:/roles
         * @secure
         */
        listRoles: (query, params = {}) => this.request({
            path: `/roles`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name CreateRole
         * @summary Create Role
         * @request POST:/roles
         * @secure
         */
        createRole: (data, params = {}) => this.request({
            path: `/roles`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description List role fields. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name ListRoleFields
         * @summary List Role Fields
         * @request GET:/roles/fields
         * @secure
         */
        listRoleFields: (params = {}) => this.request({
            path: `/roles/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Delete a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name DeleteRole
         * @summary Delete Role
         * @request DELETE:/roles/{role_id}
         * @secure
         */
        deleteRole: (roleId, params = {}) => this.request({
            path: `/roles/${roleId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name GetRole
         * @summary Get Role
         * @request GET:/roles/{role_id}
         * @secure
         */
        getRole: (roleId, params = {}) => this.request({
            path: `/roles/${roleId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update a role. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags roles
         * @name UpdateRolePermissions
         * @summary Update Role Permissions
         * @request PATCH:/roles/{role_id}
         * @secure
         */
        updateRolePermissions: (roleId, data, params = {}) => this.request({
            path: `/roles/${roleId}`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
    users = {
        /**
         * @description List all users. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name ListUsers
         * @summary List Users
         * @request GET:/users
         * @secure
         */
        listUsers: (query, params = {}) => this.request({
            path: `/users`,
            method: "GET",
            query: query,
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Create a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name CreateUser
         * @summary Create User
         * @request POST:/users
         * @secure
         */
        createUser: (data, params = {}) => this.request({
            path: `/users`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Activate a user based on an invitation token.
         *
         * @tags users
         * @name ActivateUser
         * @summary Activate User
         * @request POST:/users/activate
         * @secure
         */
        activateUser: (data, params = {}) => this.request({
            path: `/users/activate`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Get current user.
         *
         * @tags users
         * @name GetCurrentUser
         * @summary Get Current User
         * @request GET:/users/current
         * @secure
         */
        getCurrentUser: (params = {}) => this.request({
            path: `/users/current`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Accept terms and conditions.
         *
         * @tags users
         * @name AcceptTermsOfService
         * @summary Accept Terms Of Service
         * @request POST:/users/current/accept-tos
         * @secure
         */
        acceptTermsOfService: (params = {}) => this.request({
            path: `/users/current/accept-tos`,
            method: "POST",
            secure: true,
            ...params,
        }),
        /**
         * @description Update password.
         *
         * @tags users
         * @name ChangePassword
         * @summary Change Password
         * @request PUT:/users/current/password
         * @secure
         */
        changePassword: (data, params = {}) => this.request({
            path: `/users/current/password`,
            method: "PUT",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description List user fields. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name ListUserFields
         * @summary List User Fields
         * @request GET:/users/fields
         * @secure
         */
        listUserFields: (params = {}) => this.request({
            path: `/users/fields`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get user information based on an invitation token
         *
         * @tags users
         * @name GetInvitationTokenInfo
         * @summary Get Invitation Token Info
         * @request POST:/users/invitation-token-info
         * @secure
         */
        getInvitationTokenInfo: (data, params = {}) => this.request({
            path: `/users/invitation-token-info`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Invite a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name InviteUser
         * @summary Invite User
         * @request POST:/users/invite
         * @secure
         */
        inviteUser: (data, params = {}) => this.request({
            path: `/users/invite`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
        /**
         * @description Request a password reset.
         *
         * @tags users
         * @name RequestPasswordReset
         * @summary Request Password Reset
         * @request POST:/users/password-reset
         * @secure
         */
        requestPasswordReset: (data, params = {}) => this.request({
            path: `/users/password-reset`,
            method: "POST",
            body: data,
            secure: true,
            type: ContentType.Json,
            ...params,
        }),
        /**
         * @description Delete a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name DeleteUser
         * @summary Delete User
         * @request DELETE:/users/{user_id}
         * @secure
         */
        deleteUser: (userId, params = {}) => this.request({
            path: `/users/${userId}`,
            method: "DELETE",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Get a user. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name GetUser
         * @summary Get User
         * @request GET:/users/{user_id}
         * @secure
         */
        getUser: (userId, params = {}) => this.request({
            path: `/users/${userId}`,
            method: "GET",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Generate new invite token for user. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name RegenerateInviteToken
         * @summary Regenerate Invite Token
         * @request POST:/users/{user_id}/regenerate-invite-token
         * @secure
         */
        regenerateInviteToken: (userId, params = {}) => this.request({
            path: `/users/${userId}/regenerate-invite-token`,
            method: "POST",
            secure: true,
            format: "json",
            ...params,
        }),
        /**
         * @description Update the role of user. **Accepted permissions:** * SYSTEM_MANAGEMENT
         *
         * @tags users
         * @name UpdateUserRole
         * @summary Update User Role
         * @request PATCH:/users/{user_id}/role
         * @secure
         */
        updateUserRole: (userId, data, params = {}) => this.request({
            path: `/users/${userId}/role`,
            method: "PATCH",
            body: data,
            secure: true,
            type: ContentType.Json,
            format: "json",
            ...params,
        }),
    };
}
//# sourceMappingURL=data:application/json;base64,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